import { render, staticRenderFns } from "./DescricaoEnvelope.vue?vue&type=template&id=49915019"
import script from "./DescricaoEnvelope.vue?vue&type=script&lang=js"
export * from "./DescricaoEnvelope.vue?vue&type=script&lang=js"
import style0 from "./DescricaoEnvelope.vue?vue&type=style&index=0&id=49915019&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports